module.exports = __webpack_public_path__ + "static/RamyaK-28d019b2d4d6bb9ada84f5a40b946218.png";